<template>
  <main>
    <div id="printContainer" class="main-grid">
      <div class="aside">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'home' }">
            <font-awesome-icon :icon="[ 'fas', 'home' ]" />
          </el-breadcrumb-item>
          <el-breadcrumb-item>比較公司</el-breadcrumb-item>
        </el-breadcrumb>
        <h4>比較公司</h4>
        <div class="separate-title">依比較公司呈現</div>
        <ul
          class="list list--aside"
          v-loading="isCompanyDataLoading">
          <li
            class="item"
            :key="item.index"
            v-for="item in sideMenuCompanyList">
            <router-link
              class="link"
              :class="{active:item.isActive}"
              :to="item.route">
              {{item.label}}
            </router-link>
          </li>
        </ul>
        <div class="separate-title">依比較項目呈現</div>
        <ul
          class="list list--aside"
          v-loading="isCompanyDataLoading">
          <li
            class="item"
            :key="item.index"
            v-for="item in sideMenuItemList">
            <router-link
              class="link"
              :class="{active:item.isActive}"
              :to="item.route">
              {{item.label}}
            </router-link>
          </li>
        </ul>
        <section>
          <RecentQuery v-if="isShowRecentQuery">
          </RecentQuery>
        </section>
      </div>
      <!-- <div
        class="container"
        :is="pageComponent"
        :menuIndex="menuIndex">
      </div> -->
      <router-view class="container"></router-view>
    </div>
    <MainPageFloatButton
      :downloadAction="downloadAction">
    </MainPageFloatButton>
    <CompareCompanyDetailDownloader
      :active.sync="isActiveCompanyDetailDownloader"
      :companyList="downloadCompanyData">
    </CompareCompanyDetailDownloader>
  </main>
</template>

<script>
import * as apis from '@/apis/index.ts'
import routerService from '@/utils/routerService.js'
import moment from 'moment'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import * as codes from '@/const/codes.ts'
import recentQueryStorage from '@/storage/recentQueryStorage.js'
import RecentQuery from '@/components/RecentQuery/RecentQuery.vue'
import MainPageFloatButton from '@/components/MainPageFloatButton/MainPageFloatButton.vue'
import CompareCompanyDetailDownloader from '@/components/CompareCompanyDetailDownloader/CompareCompanyDetailDownloader.vue'
// import CompareCompanyPage from './CompareCompanyPage.vue'
// import CompareItemPage from './CompareItemPage.vue'
import { defaultRelevenceParams } from '@/const/defaultRelevenceParams'

export default {
  components: {
    RecentQuery,
    MainPageFloatButton,
    CompareCompanyDetailDownloader
    // CompareCompanyPage,
    // CompareItemPage
  },
  data () {
    return {
      isActiveCompanyDetailDownloader: false,
      downloadCompanyData: [],
      isShowRecentQuery: false
    }
  },
  computed: {
    ...mapState([
      'originRouteQuery'
    ]),
    ...mapState('multiCompanyDetail', [
      'uniIDList',
      'showList',
      'getList',
      'isCompanyDataLoading',
      'isCompanyNewsLoading',
      'multiCompanyData',
      'multiCompanyNews'
    ]),
    ...mapGetters([
      'getterLimitD',
      'getterLimitE',
      'getterLimitF',
      'getterLimitG',
    ]),
    menuIndex () {
      if (this.$route.params && this.$route.params.menuIndex) {
        return this.$route.params.menuIndex
      } else {
        return null
      }
    },
    // pageComponent () {
    //   if (this.multiCompanyData.length) {
    //     const findItem = this.multiCompanyData.find(d => d.basic.uniID == this.menuIndex)
    //     if (findItem) {
    //       return 'CompareCompanyPage'
    //     } else {
    //       return 'CompareItemPage'
    //     }
    //   } else {
    //     return null
    //   }
    // },
    // 側邊比較公司選單
    sideMenuCompanyList () {
      let companyList = []
      if (this.multiCompanyData.length) {
        companyList = this.multiCompanyData.map(d => {
          return {
            label: d.basic.company_name,
            route: {
              name: 'multiCompanyDetailByCompany',
              params: {
                menuIndex: d.basic.uniID
              },
              query: this.originRouteQuery
            },
            isActive: d.basic.uniID == this.menuIndex,
            index: d.basic.uniID
          }
        })
      }
      return companyList
    },
    // 側邊比較項目選單
    sideMenuItemList () {
      let getList = []
      if (this.showList.length) {
        getList = this.showList.map(d => {
          return {
            label: codes.COMPANY_ITEM_MAP[d].name,
            route: {
              name: 'multiCompanyDetailByItem',
              params: {
                menuIndex: d
              },
              query: this.originRouteQuery
            },
            isActive: d === this.menuIndex,
            index: d
          }
        })
      }
      return getList
    },
  },
  methods: {
    ...mapActions('multiCompanyDetail', [
      'actionMultiCompanyNews',
      'actionMultiCompanyDetail',
      'actionMultiCompanyDbs'
    ]),
    ...mapMutations('multiCompanyDetail', [
      'mutationUniIDList',
      'mutationGetList',
      'mutationShowList'
    ]),
    // 下載
    async downloadAction () {
      try {
        // -- 如無權限則離開 --
        if (this.getterLimitD === false &&
        this.getterLimitE === false &&
        this.getterLimitF === false &&
        this.getterLimitG === false) {
          this.isActiveCompanyDetailDownloader = false
          return
        }
        // -- 取得資料 ---
        // const result:apiInterfaces.ICompanyGetResponse = await fetchCompanyDetail(this.currentUniID)
        // 取得所有資料（news除外）
        let get = {}
        this.getList.forEach(d => {
          get[d] = { 'page-size': d === 'news' ? 500 : 10000 }
          if (d === '登記地址近似公司') {
            get[d] = {
              ...get[d],
              ...defaultRelevenceParams
            }
          }
        })

        // 取得資料
        let promiseList = []
        this.uniIDList.forEach((uniID,i) => {
          const searchRequest = {
            get,
            uniID
          }
          promiseList.push(apis.companyGet(searchRequest))
        })
        
        const resultData = await Promise.all(promiseList)

        for (let result of resultData) {
          if (result.success === false) {
            this.isActiveCompanyDetailDownloader = false
            return
          }
        }
        this.downloadCompanyData = resultData.map(d => d.payload)
        this.isActiveCompanyDetailDownloader = true

        // 要等至pdf完成後才結束loading
        await new Promise(resolve => {
          let check = () => {
            // console.log(this.isActiveCompanyDetailDownloader)
            setTimeout(() => {
              if (this.isActiveCompanyDetailDownloader === false) {
                resolve()
              } else {
                check()
              }
            }, 1000)
          }
          check()
        })
        return
      } catch (e) {
        console.error(e)
        return
      }
    },
  },
  async created () {
    // 取得網址參數
    let uniIDList = this.originRouteQuery.uniIDs.split(',').map(d => d)
    let get = JSON.parse(this.originRouteQuery.get)
    let show = JSON.parse(this.originRouteQuery._show)
    // -- 刪除無權限的get條件（非正常操作情況，預防由網址直接開啟網頁） --
    // 基本資料
    if (this.getterLimitD === false) {
      delete get.shareholders
      delete get.managers
      delete get.company_branchs
      delete get.factorys
      let shareholdersIndex = show.indexOf('shareholders')
      if (shareholdersIndex >= 0) show.splice(shareholdersIndex, 1)
      let managersIndex = show.indexOf('managers')
      if (managersIndex >= 0) show.splice(managersIndex, 1)
      let companyBranchsIndex = show.indexOf('company_branchs')
      if (companyBranchsIndex >= 0) show.splice(companyBranchsIndex, 1)
      let factorysIndex = show.indexOf('factorys')
      if (factorysIndex >= 0) show.splice(factorysIndex, 1)
    }
    // 風險指標
    if (this.getterLimitE === false) {
      // delete get.verdicts
      // delete get.news
      delete get.disputes
      delete get.procurement_bad_vendors
      let disputesIndex = show.indexOf('disputes')
      if (disputesIndex >= 0) show.splice(disputesIndex, 1)
      let procurementbadVendorsIndex = show.indexOf('procurement_bad_vendors')
      if (procurementbadVendorsIndex >= 0) show.splice(procurementbadVendorsIndex, 1)
    }
    // 經營指標
    if (this.getterLimitF === false) {
      delete get.trades
      delete get.procurements
      delete get.job104s_jobs
      delete get.patents
      delete get.awards
      let tradesIndex = show.indexOf('trades')
      if (tradesIndex >= 0) show.splice(tradesIndex, 1)
      let procurementsIndex = show.indexOf('procurements')
      if (procurementsIndex >= 0) show.splice(procurementsIndex, 1)
      let job104sJobsIndex = show.indexOf('job104s_jobs')
      if (job104sJobsIndex >= 0) show.splice(job104sJobsIndex, 1)
      let patentsIndex = show.indexOf('patents')
      if (patentsIndex >= 0) show.splice(patentsIndex, 1)
      let awardsIndex = show.indexOf('awards')
      if (awardsIndex >= 0) show.splice(awardsIndex, 1)
    }
    // 財務指標
    if (this.getterLimitG === false) {
      delete get.publics_news
      delete get.revenue_history
      delete get.ifrss_summary
      let publicsNewsIndex = show.indexOf('publics_news')
      if (publicsNewsIndex >= 0) show.splice(publicsNewsIndex, 1)
      let revenueHistoryIndex = show.indexOf('revenue_history')
      if (revenueHistoryIndex >= 0) show.splice(revenueHistoryIndex, 1)
      let ifrssSummaryIndex = show.indexOf('ifrss_summary')
      if (ifrssSummaryIndex >= 0) show.splice(ifrssSummaryIndex, 1)
    }

    // 紀錄公司詳細資料清單
    let getList = []
    Object.keys(get).forEach(d => getList.push(d))
    this.mutationUniIDList(uniIDList)
    this.mutationGetList(getList)
    this.mutationShowList(show)

    // 判斷是否有企業背景資料（獨立API）
    if (show.includes('dbs')) {
      this.actionMultiCompanyDbs(uniIDList)
    }

    // 判斷是否有新聞資料
    let isGetNews = getList.includes('news')

    // -- 查詢 --
    if (isGetNews) {
      let getWithoutNews = JSON.parse(JSON.stringify(get))
      delete getWithoutNews.news
      this.actionMultiCompanyNews(uniIDList)
      await this.actionMultiCompanyDetail({
        uniIDList: uniIDList,
        get: getWithoutNews
      })
    } else {
      await this.actionMultiCompanyDetail({
        uniIDList: uniIDList,
        get
      })
    }

    // -- 紀錄最近查詢 --
    try {
      let keyword = ''
      if (this.sideMenuCompanyList.length) {
        keyword = this.sideMenuCompanyList.map(d => d.label).join(',')
      } else {
        return
      }
      // 存入localStorage
      recentQueryStorage.insert(keyword, this.$route)
      // 顯示
      this.isShowRecentQuery = true
    }
    catch (e) {
    }
  },
  watch: {
    '$route.query': {
      handler (q) {
        // 如果網址參數是原始參數的話，重新再導向到短網址
        if (this.$route.query.uniIDs && this.$route.query.get && this.$route.query._show) {
          routerService('replace', {
            name: this.$route.name,
            params: this.$route.params,
            query: this.$route.query
          })
          return
        }
      },
      immediate: true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.$route.params.menuIndex) {
        routerService('replace', { name: 'home' })
        return
      }
      if (!vm.$route.query.query) {
        routerService('replace', { name: 'home' })
        return
      }
      if (vm.getterLimitD === false &&
      vm.getterLimitE === false &&
      vm.getterLimitF === false &&
      vm.getterLimitG === false) {
        // 全無權限導回首頁
        routerService('replace', { name: 'home' })
      }
    })
  }
}
</script>
